import type { FC, ReactNode } from 'react';

interface ShowProps {
  when: boolean;
  fallback?: ReactNode;
  children: ReactNode;
}

export const Show: FC<ShowProps> = ({ when, fallback = null, children }) => {
  return when ? <>{children}</> : <>{fallback}</>;
};
